import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"
import { MyTasks } from "@/components/project/ProjectDataSheet/MyTasks"

// `focusTask` carries a planned_site_id (e.g. from the map popup's Details
// button) so the list can auto-expand and scroll to that task on open.
const searchSchema = z.object({
  focusTask: z.string().optional(),
})

export const Route = createFileRoute("/_private/projects/$id/data/tasks/")({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  const { focusTask } = Route.useSearch()
  return (
    <MyTasks
      focusTask={focusTask}
      onBack={() => navigate({ to: "/projects/$id/data", params: { id } })}
    />
  )
}
